'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('./../../../external/classnames/index.js');
var PropTypes = require('prop-types');
var NavItem = require('./NavItem/NavItem.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefault(React);
var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var Nav = function Nav(_ref) {
  var className = _ref.className,
    setActiveItemCb = _ref.setActiveItemCb,
    activeNavItem = _ref.activeNavItem,
    navItems = _ref.navItems,
    landingName = _ref.landingName;
  var NavClasses = index.default(className, 'lanl-nav');
  return /*#__PURE__*/React__default.default.createElement("div", {
    "data-testid": "lanl-nav",
    className: NavClasses
  }, navItems.map(function (_ref2, i) {
    var name = _ref2.name,
      link = _ref2.link;
    return /*#__PURE__*/React__default.default.createElement(NavItem.NavItem, {
      key: "nav-item-".concat(i),
      onClick: name === 'MISSION' ? function () {
        return window.location.href = link;
      } : function () {
        return setActiveItemCb(name);
      },
      active: (name === null || name === void 0 ? void 0 : name.toUpperCase()) === ((activeNavItem === null || activeNavItem === void 0 ? void 0 : activeNavItem.toUpperCase()) || (landingName === null || landingName === void 0 ? void 0 : landingName.toUpperCase()))
    }, name);
  }));
};
Nav.defaultProps = {
  activeNavItem: null,
  landingName: '',
  navItems: [],
  searchIsActive: false,
  setActiveItemCb: function setActiveItemCb() {}
};
Nav.propTypes = {
  activeNavItem: PropTypes__default.default.string,
  className: PropTypes__default.default.string,
  landingName: PropTypes__default.default.string,
  navItems: PropTypes__default.default.array,
  searchIsActive: PropTypes__default.default.bool,
  setActiveItemCb: PropTypes__default.default.func
};

exports.Nav = Nav;
exports.default = Nav;
//# sourceMappingURL=Nav.js.map
